<app-header></app-header>
<div class="spacer"></div>

<div class="container">
  <div class="row">
    <div class="col-md-8">
      <img
        class="img-fluid light-shadow"
        [src]="randomImageUrl"
        [alt]="ArticleDetails.title"
        loading="lazy"
        style="max-width: 100%;"
      />
      <h2>{{ ArticleDetails.title }}</h2>
      <mat-divider></mat-divider>
      <div class="ql-container ql-snow border-0 h-auto mb-4">
        <div class="ql-editor ps-0 pe-5" [innerHTML]="ArticleDetails.content"></div>
      </div>
    </div>

    <div class="col-md-4">
      <!-- Latest Blogs Section -->
      <div class="sidebar-section mb-4">
        <h3 class="sidebar-title text-center border-bottom pb-2">Latest Blogs</h3>
        <ul class="featured-blogs-list list-unstyled mt-3">
          <li *ngFor="let item of latestFive">
            <a [routerLink]="['/blog', item.slug]" class="featured-blog-link">
              <span class="bullet">&#8226;</span> {{ item.title }}
            </a>
          </li>
        </ul>
      </div>

      <!-- Blog Categories Section -->
      <div class="categories-section mb-4 p-3 border rounded shadow-sm">
        <h3 class="categories-title text-center border-bottom pb-2">Categories</h3>
        <ul class="category-list mt-2 ps-0">
          <li *ngFor="let category of blogCategories" class="list-unstyled">
            <a (click)="FetchAllArticles(category.id)" class="category-item">
              {{ category.category_name }}
            </a>
          </li>
        </ul>
      </div>

      <!-- Subscribe Section -->
      <div class="sidebar-section cta-section mb-4 text-center p-3 border rounded">
        <h4>Subscribe to Our Newsletter</h4>
        <p>Stay updated with the latest blog posts and news.</p>
        <button class="cta-button btn btn-primary mt-2" disabled>
          Coming Soon!
        </button>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
